import { useMemo, useState } from "react"

import { UsePopoverMultiSelectProps, UsePopoverMultiSelectRes } from "./types"
import usePopoverMultiSelect from "./usePopoverMultiSelect"

export type UseLocalSearchPopoverMultiSelectProps<T> = Omit<
  UsePopoverMultiSelectProps<T>,
  "onChangeQuery"
>

export type UseLocalSearchPopoverSelectRes<T> = UsePopoverMultiSelectRes<T>

function useLocalSearchPopoverMultiSelect<T>(
  props: UseLocalSearchPopoverMultiSelectProps<T>
): UseLocalSearchPopoverSelectRes<T> {
  const { items, labelExtractor } = props

  const [query, setQuery] = useState("")

  const filteredItems = useMemo(() => {
    return items.filter((item) =>
      labelExtractor(item).toLowerCase().includes(query.toLowerCase())
    )
  }, [items, labelExtractor, query])

  return usePopoverMultiSelect({
    ...props,
    items: filteredItems,
    onChangeQuery: setQuery,
  })
}

export default useLocalSearchPopoverMultiSelect
